import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { UserIdProvider } from './Component/ContextApi';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <UserIdProvider>
        <App />
    </UserIdProvider>

);
reportWebVitals();
